import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import GameContext from './game-context-model'
import {
  CreateGameContextAsync,
  DeleteGameContextAsync,
  LoadGameContextsAsync,
} from './gameContext-thunk'
const initialState: gameContextSliceState = {
  gameContext: [],
  selected_gameContext: '',
  is_loading_gameContext: false,
  is_creating_gameContext: false,
  is_deleting_gameContext: false,
}
export interface gameContextSliceState {
  gameContext: GameContext[]
  selected_gameContext?: string
  is_loading_gameContext: boolean
  is_creating_gameContext: boolean
  is_deleting_gameContext: boolean
}
export const gameContextSlice = createSlice({
  name: 'gameContext',
  initialState,
  reducers: {
    setSelectedgameContext: (state, action) => {
      state.selected_gameContext = action.payload
    },
    clearStategameContext: (state) => {
      state.gameContext = []
      state.is_loading_gameContext = false
      state.is_creating_gameContext = false
      state.is_deleting_gameContext = false
    },
    mergegameContext: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_gameContext = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.gameContext = merge(state.gameContext, payload) as any
        }
      }
    },

    add_gameContext: (state, action) => {
      if (action.payload) {
        state.gameContext = [...state.gameContext, action.payload]
      }
    },
    set_gameContext: (state, action) => {
      let { key, value, id } = action.payload
      state.gameContext = state.gameContext.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadGameContextsAsync.pending, (state) => {
      state.is_loading_gameContext = true
    })
    builder.addCase(LoadGameContextsAsync.fulfilled, (state, action) => {
      state.is_loading_gameContext = false
      if (action.payload) {
        state.gameContext = action.payload
      }
    })
    builder.addCase(LoadGameContextsAsync.rejected, (state) => {
      state.is_loading_gameContext = false
    })
    builder.addCase(CreateGameContextAsync.pending, (state) => {
      state.is_creating_gameContext = true
    })
    builder.addCase(CreateGameContextAsync.fulfilled, (state) => {
      state.is_creating_gameContext = false
    })
    builder.addCase(CreateGameContextAsync.rejected, (state) => {
      state.is_creating_gameContext = false
    })
    builder.addCase(DeleteGameContextAsync.pending, (state) => {
      state.is_deleting_gameContext = true
    })
    builder.addCase(DeleteGameContextAsync.fulfilled, (state, action) => {
      state.is_deleting_gameContext = false
      if (state.gameContext) {
        state.gameContext = state.gameContext.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteGameContextAsync.rejected, (state) => {
      state.is_deleting_gameContext = false
    })
  },
})

export const {
  clearStategameContext,
  setSelectedgameContext,
  set_gameContext,
  mergegameContext,
  add_gameContext,
} = gameContextSlice.actions

export const get_gameContext =
  (id?: string) =>
  (state: {
    gameContext: {
      gameContext: GameContext[]
    }
  }): GameContext | null => {
    let temp = state?.gameContext?.gameContext?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.gameContext?.gameContext[0] || null
  }
export const get_selected_gameContext = (state: {
  gameContext: gameContextSliceState
}): GameContext | null => {
  let id = state?.gameContext?.selected_gameContext
  let temp = state?.gameContext?.gameContext?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_gameContext = (state: {
  gameContext: {
    gameContext: GameContext[]
  }
}): GameContext[] => {
  let temp = state?.gameContext?.gameContext
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_gameContext_busy = (state: {
  gameContext: gameContextSliceState
}) => {
  return (
    state?.gameContext.is_deleting_gameContext ||
    state?.gameContext.is_loading_gameContext ||
    state?.gameContext.is_creating_gameContext
  )
}
export const is_deleting_gameContext_busy = (state: {
  gameContext: gameContextSliceState
}) => {
  return state?.gameContext.is_deleting_gameContext
}
export const is_loading_gameContext_busy = (state: {
  gameContext: gameContextSliceState
}) => {
  return state?.gameContext.is_loading_gameContext
}
export const is_creating_gameContext_busy = (state: {
  gameContext: gameContextSliceState
}) => {
  return state?.gameContext.is_creating_gameContext
}

export default gameContextSlice.reducer
